// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"bbefa58c","627":"e654acdc","969":"bbefa58c"}[chunkId] + ".chunk.css";
};